import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import Footer from "../components/footer/Footer";
import { Container, Row, Col } from "react-bootstrap";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import EmployeeRestrictionsSection from '../components/employeeRestrictions/employeeRestrictionssection'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";

const GET_EMPLOYEETYES = gql`
query($id:Int){
    getEmployeeTypes(id:$id){
        id
        employee_type 
      }
}
`

const GET_COLLEGEMODULES = gql`
query($institute_id:Int $branch_id : Int){
    getCollegeModules(institute_id:$institute_id branch_id : $branch_id){
        id
        module_name 
      }
}
`

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
     
      globalBranches {
        id
        branch_name
      }
      offlineExamSubjects{
        id
        subject
      }
    }
  }
`;

const GET_EMPLOYEE_DETAILS = gql`
query($institute_id:Int,$branch_id:Int){
    getEmployeeDetails(institute_id:$institute_id,branch_id:$branch_id){
        employee_name
        emp_email
        institute_id
        branch_id
        branch_name
        employee_type
        moduleAcsess{
          module_name
          enabled
        }
        subject_ids
        password
        employeeId
        emp_mobile
        
      }
}
`

class EmployeeRestrictions extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {

        if (Cookies.get("token") == undefined) this.props.history.push("/login");

        const getEmployeeTypes = this.props.getEmployeeTypes;
        const loading = getEmployeeTypes.loading
        const error = getEmployeeTypes.error;

        const getCollegeModules = this.props.getCollegeModules;
        const loading2 = getCollegeModules.loading
        const error2 = getCollegeModules.error

        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        const getEmployeeDetails = this.props.getEmployeeDetails;
        const loading4 = getEmployeeDetails.loading;
        const error4 = getEmployeeDetails.error;

        if (error !== undefined) {
            alert("Server Error. " + error.message);
            return null;
        }
        if (error4 !== undefined) {
            alert("Server Error. " + error4.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        return (

            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
                        <Container fluid>
                            {
                                loading || loading1 || loading2 || loading4 ?
                                    (
                                        <Container><Row className="my-3">
                                            <Col>
                                                <div class="spinner-border text-primary text-center loading-img-center"></div>
                                            </Col>
                                        </Row>
                                        </Container>
                                    )
                                    :
                                    (
                                        <EmployeeRestrictionsSection
                                            getEmployeeTypes={getEmployeeTypes.getEmployeeTypes}
                                            getCollegeModules={getCollegeModules.getCollegeModules}
                                            globals={globals.globals}
                                            getEmployeeDetails={getEmployeeDetails.getEmployeeDetails}
                                        />

                                    )
                            }
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(
    compose(
        graphql(GET_EMPLOYEETYES, {
            options: (props) => ({
                variables: {
                    id: 0,
                },
            }),
            name: "getEmployeeTypes",
        }),
        graphql(GET_COLLEGEMODULES, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id:parseInt(Cookies.get("branch_id"))
                },
                fetchPolicy: 'network-only'
            }),
            name: "getCollegeModules",
        }),
        graphql(FETCH_GLOBALS, {
            options: (props) => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                },
            }),
            name: "globals",
        }),
        graphql(GET_EMPLOYEE_DETAILS, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id:0
                },
            }),
            name: "getEmployeeDetails",
        }),
    )(EmployeeRestrictions)
);